var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"homeManage"}},[_vm._v(" 我是手机页面的 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }